import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";
import { LearningTrackingActionTypes } from "src/app/constants/StoreConstants";

export const IsEnableLearningTabByLearnerId = createAction(
  LearningTrackingActionTypes.IsEnableLearningTab,
  props<{learnerId: number, courseId: number}>()
);

export const IsEnableLearningTabByLearnerIdSuccess = createAction(
  LearningTrackingActionTypes.IsEnableLearningTabSuccess,
  props<{isEnabledLearningTab: boolean}>()
);

export const IsEnableLearningTabByLearnerIdError = createAction(
  LearningTrackingActionTypes.IsEnableLearningTabError,
  props<{error: HttpErrorResponse}>()
);